import Page from './Page';
import PageContainer from './Page.container';

export default PageContainer(Page);
